/* Oddity theme — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var S = T.strings || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------ Money */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || T.moneyFormat || '{{amount}}';
    var withDelims = function (n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var fixed = (n / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    };
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelims(cents, 0, ' '); break;
      default: value = withDelims(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  var sized = function (url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };
  var escapeHtml = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* ------------------------------------------------------------ Header condense */
  var root = document.documentElement;
  var onScroll = function () { root.classList.toggle('is-condensed', window.scrollY > 40); };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ------------------------------------------------------------ Overlays */
  var openOverlay = null;
  var lastFocus = null;
  function open(name) {
    var el = $('[data-drawer="' + name + '"]');
    if (!el) return false;
    if (openOverlay) close();
    lastFocus = document.activeElement;
    el.hidden = false;
    openOverlay = el;
    document.body.style.overflow = 'hidden';
    var focusEl = $('[data-search-input]', el) || $('button, a, input, select', el);
    if (focusEl) setTimeout(function () { focusEl.focus(); }, 50);
    if (name === 'cart') refreshCart();
    return true;
  }
  function close() {
    if (!openOverlay) return;
    openOverlay.hidden = true;
    openOverlay = null;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-overlay]');
    if (opener) {
      if (open(opener.getAttribute('data-open-overlay'))) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close-overlay]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab' && openOverlay) {
      var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea', openOverlay).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ------------------------------------------------------------ Cart */
  function getJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { Accept: 'application/json' } }, opts || {})).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var err = new Error(data.description || data.message || 'Error'); err.data = data; throw err; }
        return data;
      });
    });
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    var sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = formatMoney(cart.total_price);
    var checkout = $('[data-checkout]'); if (checkout) checkout.disabled = cart.item_count === 0;

    var shipText = $('[data-ship-text]'), shipFill = $('[data-ship-fill]');
    var threshold = Number(T.freeShippingThreshold) || 0;
    if (shipText && threshold > 0) {
      var remaining = Math.max(0, threshold - cart.total_price);
      shipText.innerHTML = remaining > 0
        ? escapeHtml(S.freeShippingRemaining || '').replace('[amount]', '<strong class="accent">' + escapeHtml(formatMoney(remaining)) + '</strong>')
        : escapeHtml(S.freeShippingUnlocked || '');
      if (shipFill) shipFill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    }

    var list = $('[data-cart-items]');
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<p class="drawer__empty faint">' + escapeHtml(S.emptyCart) + '</p>';
      return;
    }
    list.innerHTML = '<ul>' + cart.items.map(function (item, i) {
      var meta = [];
      if (!item.product_has_only_default_variant && item.variant_title) meta.push(escapeHtml(item.variant_title));
      if (item.properties) Object.keys(item.properties).forEach(function (k) { if (item.properties[k] && k.charAt(0) !== '_') meta.push(escapeHtml(item.properties[k])); });
      if (item.selling_plan_allocation) meta.push('<span class="accent">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</span>');
      var img = item.image ? '<img src="' + escapeHtml(sized(item.image, 200)) + '" alt="" loading="lazy" width="80" height="100">' : '';
      return '<li class="cline">' +
        '<a class="cline__media" href="' + escapeHtml(item.url) + '">' + img + '</a>' +
        '<div class="cline__info">' +
          '<div class="cline__top"><a class="cline__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
          '<span class="small">' + escapeHtml(formatMoney(item.final_line_price)) + '</span></div>' +
          (meta.length ? '<p class="cline__meta">' + meta.join(' · ') + '</p>' : '') +
          '<div class="cline__row">' +
            '<div class="qty">' +
              '<button type="button" class="qty__btn" data-line="' + (i + 1) + '" data-line-qty="' + (item.quantity - 1) + '" aria-label="−">−</button>' +
              '<span class="qty__val">' + item.quantity + '</span>' +
              '<button type="button" class="qty__btn" data-line="' + (i + 1) + '" data-line-qty="' + (item.quantity + 1) + '" aria-label="+">+</button>' +
            '</div>' +
            '<button type="button" class="label cline__remove" data-line="' + (i + 1) + '" data-line-qty="0">' + escapeHtml(S.remove) + '</button>' +
          '</div>' +
        '</div></li>';
    }).join('') + '</ul>';
  }
  function refreshCart() {
    return getJSON(T.routes.cart + '.js').then(renderCart).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    getJSON(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(b.getAttribute('data-line')), quantity: Math.max(0, Number(b.getAttribute('data-line-qty'))) })
    }).then(renderCart).catch(function (err) { alert(err.message); refreshCart(); });
  });

  /* ------------------------------------------------------------ Product forms */
  $$('[data-product-form]').forEach(function (form) {
    var variantsEl = $('[data-variants]', form);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = $('[data-variant-input]', form);
    var scope = form.closest('[data-product-card]') || form.closest('[data-product-page]') || form;
    var priceEl = $('[data-price]', scope);
    var compareEl = $('[data-compare]', scope);
    var addBtn = $('[data-add-button]', form);
    var addLabel = $('[data-add-label]', form);
    var planInput = $('[data-plan-input]', form);
    var isPage = !!form.closest('[data-product-page]');

    var current = function () {
      var id = Number(idInput.value);
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    };
    var allocationFor = function (variant, planId) {
      if (!planId || !variant || !variant.selling_plan_allocations) return null;
      for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
        if (String(variant.selling_plan_allocations[i].selling_plan_id) === String(planId)) return variant.selling_plan_allocations[i];
      }
      return null;
    };
    function update() {
      var v = current();
      if (!v) return;
      var planId = planInput ? planInput.value : '';
      var alloc = allocationFor(v, planId);
      var price = alloc ? alloc.price : v.price;
      if (priceEl) priceEl.textContent = formatMoney(price);
      if (compareEl) {
        var compare = alloc ? alloc.compare_at_price || v.price : v.compare_at_price;
        var show = compare && compare > price;
        compareEl.hidden = !show;
        if (show) compareEl.textContent = formatMoney(compare);
      }
      $$('[data-plan-price]', form).forEach(function (el) {
        var pid = el.getAttribute('data-plan-price');
        var a = allocationFor(v, pid);
        el.textContent = pid ? (a ? formatMoney(a.price) : '') : formatMoney(v.price);
      });
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? S.addToCart : S.soldOut;
      }
      if (isPage && v.featured_media) {
        var media = $('[data-media-id="' + v.featured_media.id + '"]');
        if (media) showMedia(String(v.featured_media.id));
      }
      if (isPage && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    var select = $('[data-variant-select]', form);
    if (select) select.addEventListener('change', function () { idInput.value = select.value; update(); });

    var optionInputs = $$('[data-option-input]', form);
    if (optionInputs.length) {
      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option-input]')) return;
        var selected = $$('[data-option-index]', form).map(function (fs) {
          var checked = $('input:checked', fs);
          return checked ? checked.value : null;
        });
        var match = variants.filter(function (v) {
          return selected.every(function (val, i) { return v.options[i] === val; });
        })[0];
        if (match) idInput.value = match.id;
        update();
      });
    }

    $$('[data-plan-radio]', form).forEach(function (r) {
      r.addEventListener('change', function () { if (planInput) planInput.value = r.value; update(); });
    });

    $$('[data-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $('input[name="quantity"]', form);
        input.value = Math.max(1, (Number(input.value) || 1) + Number(b.getAttribute('data-qty')));
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!addBtn || addBtn.disabled) return;
      var label = addLabel ? addLabel.textContent : '';
      addBtn.disabled = true;
      if (addLabel) addLabel.textContent = S.adding;
      var data = new FormData(form);
      if (planInput && !planInput.value) data.delete('selling_plan');
      getJSON(T.routes.cartAdd + '.js', { method: 'POST', body: data })
        .then(function () { return refreshCart(); })
        .then(function () { open('cart'); })
        .catch(function (err) { alert(err.message); })
        .then(function () { addBtn.disabled = false; if (addLabel) addLabel.textContent = label; });
    });
  });

  /* PDP gallery */
  function showMedia(id) {
    $$('[data-media-id]').forEach(function (m) { var on = m.getAttribute('data-media-id') === id; m.hidden = !on; m.classList.toggle('is-active', on); });
    $$('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === id); });
  }
  $$('[data-thumb]').forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });

  /* ------------------------------------------------------------ Outlet status (Asia/Jakarta) */
  function jakartaMinutes() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Jakarta', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      var h = 0, m = 0;
      parts.forEach(function (p) { if (p.type === 'hour') h = Number(p.value); if (p.type === 'minute') m = Number(p.value); });
      return h * 60 + m;
    } catch (e) {
      var d = new Date(); return ((d.getUTCHours() + 7) % 24) * 60 + d.getUTCMinutes();
    }
  }
  var toMin = function (t) {
    var m = /^(\d{1,2})[:.](\d{2})$/.exec(String(t || '').trim());
    return m ? Number(m[1]) * 60 + Number(m[2]) : null;
  };
  function outletState(openT, closeT, soon) {
    if (soon === true || soon === 'true') return { state: 'opening-soon', label: S.openingSoon };
    var o = toMin(openT), c = toMin(closeT);
    if (o === null || c === null) return { state: 'unknown', label: S.hoursTbc };
    var now = jakartaMinutes();
    var closeAdj = c <= o ? c + 1440 : c; // past midnight
    var nowAdj = now < o && c <= o ? now + 1440 : now;
    if (nowAdj < o || nowAdj >= closeAdj) return { state: 'closed', label: S.closed + ' · ' + openT + '–' + closeT };
    if (closeAdj - nowAdj <= 60) return { state: 'closing-soon', label: S.closingSoon + ' · ' + closeT };
    return { state: 'open', label: S.open + ' · ' + openT + '–' + closeT };
  }
  function paintStatus(el, st) {
    el.setAttribute('data-state', st.state);
    var label = $('.status__label', el);
    if (label) label.textContent = st.label;
  }
  function refreshStatuses() {
    $$('[data-outlet-status]').forEach(function (el) {
      paintStatus(el, outletState(el.getAttribute('data-open'), el.getAttribute('data-close'), el.getAttribute('data-soon')));
    });
  }
  refreshStatuses();
  setInterval(refreshStatuses, 60000);

  /* Distance */
  function distanceKm(lat1, lng1, lat2, lng2) {
    var R = 6371, toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad, dLng = (lng2 - lng1) * toRad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(a));
  }
  function locate() {
    return new Promise(function (resolve, reject) {
      if (!navigator.geolocation) return reject(new Error('unsupported'));
      navigator.geolocation.getCurrentPosition(function (p) { resolve(p.coords); }, reject, { timeout: 10000, maximumAge: 300000 });
    });
  }

  /* ------------------------------------------------------------ Slideshow */
  $$('[data-slideshow]').forEach(function (show) {
    var slides = $$('[data-slide]', show);
    var dots = $$('[data-slide-to]', show);
    if (slides.length < 2) return;
    var idx = 0, timer = null;
    var autoplay = show.getAttribute('data-autoplay') === 'true' && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var interval = Number(show.getAttribute('data-interval')) || 6000;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === idx;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a, button', s).forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      });
      dots.forEach(function (d, i) { var on = i === idx; d.classList.toggle('is-active', on); if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function start() { stop(); if (autoplay) timer = setInterval(function () { go(idx + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.getAttribute('data-slide-to'))); start(); }); });
    var prev = $('[data-slide-prev]', show), next = $('[data-slide-next]', show);
    if (prev) prev.addEventListener('click', function () { go(idx - 1); start(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); start(); });
    show.addEventListener('mouseenter', stop);
    show.addEventListener('mouseleave', start);
    show.addEventListener('focusin', stop);
    show.addEventListener('focusout', start);
    var x0 = null;
    show.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    show.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      x0 = null; start();
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  });

  /* ------------------------------------------------------------ Locator */
  $$('[data-locator]').forEach(function (loc) {
    var list = $('[data-outlet-list]', loc);
    var cards = $$('[data-outlet]', loc);
    var map = $('[data-map]', loc);
    var msg = $('[data-locator-msg]', loc);
    var city = 'all', openOnly = false;

    function select(card) {
      cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
      if (map && card) map.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(card.getAttribute('data-map-query')) + '&z=15&output=embed';
    }
    function applyFilters() {
      var firstVisible = null;
      cards.forEach(function (c) {
        var st = $('[data-outlet-status]', c);
        var state = st ? st.getAttribute('data-state') : '';
        var show = (city === 'all' || c.getAttribute('data-city') === city) && (!openOnly || state === 'open' || state === 'closing-soon');
        c.hidden = !show;
        if (show && !firstVisible) firstVisible = c;
      });
      if (firstVisible && (!$('.outlet.is-selected', loc) || $('.outlet.is-selected', loc).hidden)) select(firstVisible);
    }
    $$('[data-filter]', loc).forEach(function (b) {
      b.addEventListener('click', function () {
        city = b.getAttribute('data-filter');
        $$('[data-filter]', loc).forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on); });
        applyFilters();
      });
    });
    var openBtn = $('[data-filter-open]', loc);
    if (openBtn) openBtn.addEventListener('click', function () {
      openOnly = !openOnly;
      openBtn.classList.toggle('is-active', openOnly);
      openBtn.setAttribute('aria-pressed', openOnly);
      applyFilters();
    });
    cards.forEach(function (c) {
      c.addEventListener('click', function (e) { if (!e.target.closest('a')) select(c); });
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target === c) select(c); });
    });

    function nearMe() {
      locate().then(function (pos) {
        var withD = cards.map(function (c) {
          var lat = parseFloat(c.getAttribute('data-lat')), lng = parseFloat(c.getAttribute('data-lng'));
          var d = isNaN(lat) || isNaN(lng) ? Infinity : distanceKm(pos.latitude, pos.longitude, lat, lng);
          var dEl = $('[data-distance]', c);
          if (dEl) dEl.textContent = isFinite(d) ? '· ' + (d < 10 ? d.toFixed(1) : Math.round(d)) + ' km' : '';
          return { c: c, d: d };
        }).sort(function (a, b) { return a.d - b.d; });
        withD.forEach(function (x) { list.appendChild(x.c); });
        if (withD.length) select(withD[0].c);
        if (msg) msg.hidden = true;
      }).catch(function () {
        if (msg) { msg.textContent = S.locationDenied; msg.hidden = false; }
      });
    }
    var nearBtn = $('[data-near-me]', loc);
    if (nearBtn) nearBtn.addEventListener('click', nearMe);

    var hashCard = window.location.hash && $(window.location.hash, loc);
    select(hashCard && hashCard.matches('[data-outlet]') ? hashCard : cards[0]);
    if (/[?&]near=me/.test(window.location.search)) nearMe();
  });

  /* ------------------------------------------------------------ Wholesale estimator */
  $$('[data-estimator]').forEach(function (est) {
    var form = $('form', est);
    var steps = $$('[data-step]', est);
    var idx = 0;
    var tiersEl = $('[data-tiers]', est);
    var tiers = tiersEl ? JSON.parse(tiersEl.textContent).filter(function (t) { return t.price > 0; }).sort(function (a, b) { return a.min - b.min; }) : [];
    var vol = $('[data-volume]', est);

    function show(i) {
      idx = i;
      steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      $$('[data-step-dot]', est).forEach(function (d, n) { d.classList.toggle('is-active', n === i); d.classList.toggle('is-done', n < i); });
      if (i === steps.length - 1) buildReview();
      var top = form.getBoundingClientRect().top + window.scrollY - 120;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
    function valid(step) {
      var fields = $$('input, textarea, select', step);
      for (var i = 0; i < fields.length; i++) if (!fields[i].checkValidity()) { fields[i].reportValidity(); return false; }
      return true;
    }
    function buildReview() {
      var out = $('[data-review]', est);
      if (!out) return;
      var data = new FormData(form), rows = [];
      data.forEach(function (value, key) {
        var m = /^contact\[(.+)\]$/.exec(key);
        if (!m || !value || m[1] === 'Inquiry') return;
        var label = m[1] === 'name' ? 'Name' : m[1] === 'email' ? 'Email' : m[1] === 'phone' ? 'WhatsApp' : m[1] === 'body' ? 'Notes' : m[1];
        rows.push('<div><dt>' + escapeHtml(label) + '</dt><dd>' + escapeHtml(value) + '</dd></div>');
      });
      out.innerHTML = rows.join('');
    }
    $$('[data-step-next]', est).forEach(function (b) { b.addEventListener('click', function () { if (valid(steps[idx])) show(Math.min(idx + 1, steps.length - 1)); }); });
    $$('[data-step-back]', est).forEach(function (b) { b.addEventListener('click', function () { show(Math.max(idx - 1, 0)); }); });

    function estimate() {
      if (!vol) return;
      var kg = Number(vol.value);
      $$('[data-volume-out], [data-est-volume]', est).forEach(function (el) { el.textContent = kg; });
      if (!tiers.length) return;
      var tier = null;
      tiers.forEach(function (t) { if (kg >= t.min) tier = t; });
      var tierEl = $('[data-est-tier]', est), priceEl = $('[data-est-price]', est), monthEl = $('[data-est-month]', est);
      if (!tier) { tierEl.textContent = '—'; priceEl.textContent = '—'; monthEl.textContent = '—'; return; }
      tierEl.textContent = tier.name;
      priceEl.textContent = formatMoney(tier.price);
      monthEl.textContent = formatMoney(Math.round(tier.price * kg * 52 / 12));
    }
    if (vol) { vol.addEventListener('input', estimate); estimate(); }

    // If Shopify returned errors, jump to the details step so they're visible
    if ($('.notice--err', est)) show(1);
  });

  /* ------------------------------------------------------------ Auto-submit selects / filters */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-auto-submit]')) e.target.form.submit();
  });

  /* ------------------------------------------------------------ Predictive search */
  var sInput = $('[data-search-input]');
  var sResults = $('[data-search-results]');
  if (sInput && sResults && T.routes.predictiveSearch) {
    var timer, lastQ = '';
    sInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = sInput.value.trim();
      if (!q) { sResults.innerHTML = ''; return; }
      timer = setTimeout(function () {
        lastQ = q;
        var url = T.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,page,article&resources[limit]=6&resources[options][unavailable_products]=last';
        getJSON(url).then(function (data) {
          if (q !== lastQ) return;
          var r = (data.resources && data.resources.results) || {};
          var products = r.products || [], pages = (r.pages || []).concat(r.articles || []);
          if (!products.length && !pages.length) {
            sResults.innerHTML = '<p class="faint">' + escapeHtml(S.noResults) + '</p>';
            return;
          }
          var html = '<div class="sresults"><div><p class="label faint">' + escapeHtml(S.products) + '</p><ul class="sresults__list">' +
            products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + escapeHtml(sized(p.featured_image.url, 120)) + '" alt="" loading="lazy">' : '';
              var price = p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
              return '<li><a class="sresult" href="' + escapeHtml(p.url) + '">' + img + '<span class="sresult__title">' + escapeHtml(p.title) + '</span><span class="small muted">' + escapeHtml(price) + '</span></a></li>';
            }).join('') + '</ul></div>' +
            '<div><p class="label faint">' + escapeHtml(S.pages) + '</p><ul class="sresults__list">' +
            pages.map(function (p) { return '<li><a class="sresult" href="' + escapeHtml(p.url) + '"><span class="sresult__title">' + escapeHtml(p.title) + '</span></a></li>'; }).join('') +
            '</ul><p><a class="label link-under muted" href="' + escapeHtml(T.routes.search) + '?q=' + encodeURIComponent(q) + '">' + escapeHtml(S.viewAll) + ' →</a></p></div></div>';
          sResults.innerHTML = html;
        }).catch(function () {});
      }, 250);
    });
  }

  /* ------------------------------------------------------------ Reveal + parallax */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }
  /* ------------------------------------------------------------ Customer login: recover toggle */
  $$('[data-toggle-recover]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var r = $('#RecoverForm'), l = $('#LoginForm');
      if (r && l) { r.hidden = !r.hidden; l.hidden = !l.hidden; }
    });
  });
  if (window.location.hash === '#recover') { var r0 = $('#RecoverForm'), l0 = $('#LoginForm'); if (r0 && l0) { r0.hidden = false; l0.hidden = true; } }

  /* ------------------------------------------------------------ Curiosity Bar: vibe tabs */
  $$('[data-vibe-selector]').forEach(function (root) {
    var tabs = $$('[data-vibe-tab]', root);
    var panels = $$('[data-vibe-panel]', root);
    var select = function (i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) { panels[j].hidden = !on; panels[j].classList.toggle('is-active', on); }
      });
      if (focus) tabs[i].focus();
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = tabs.length;
        if (k === 'ArrowRight' || k === 'ArrowDown') { e.preventDefault(); select((i + 1) % n, true); }
        if (k === 'ArrowLeft' || k === 'ArrowUp') { e.preventDefault(); select((i - 1 + n) % n, true); }
        if (k === 'Home') { e.preventDefault(); select(0, true); }
        if (k === 'End') { e.preventDefault(); select(n - 1, true); }
      });
    });
    /* Theme editor: selecting a vibe block opens its panel */
    document.addEventListener('shopify:block:select', function (e) {
      var i = tabs.indexOf(e.target);
      if (i > -1) select(i);
    });
  });

  /* ------------------------------------------------------------ Vibe Check: swipe gallery dots */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('[data-gallery-track]', g);
    var dots = $$('.vibe-card__dot', g);
    if (!track || dots.length < 2) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }, { passive: true });
  });

  /* ------------------------------------------------------------ Inline email sign-ups (no reload) */
  $$('form[data-ajax-signup]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.dataset.native === '1' || !window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = $('button[type="submit"]', form);
      if (btn) btn.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        .then(function (res) {
          /* Shopify may ask for a captcha: fall back to a normal submit */
          if (!res.ok || /challenge/.test(res.url)) throw new Error('fallback');
          var row = $('.mini-form__row', form), micro = $('.mini-form__micro', form), ok = $('.mini-form__ok', form);
          if (row) row.hidden = true;
          if (micro) micro.hidden = true;
          if (ok) ok.hidden = false;
        })
        .catch(function () { form.dataset.native = '1'; if (btn) btn.disabled = false; form.submit(); });
    });
  });

  /* ------------------------------------------------------------ Date inputs: no past dates */
  $$('input[type="date"][data-min-today]').forEach(function (el) {
    var d = new Date(); d.setDate(d.getDate() + 1);
    el.min = d.toISOString().slice(0, 10);
  });

  /* ------------------------------------------------------------ "Apply" / "Book" buttons preselect the form */
  [['data-pick-role', '[data-role-select]'], ['data-pick-workshop', '[data-workshop-select]']].forEach(function (pair) {
    $$('[' + pair[0] + ']').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sel = $(pair[1]);
        if (sel) sel.value = btn.getAttribute(pair[0]);
      });
    });
  });

  /* Keep header cart count in sync after page load (e.g. back/forward cache) */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  refreshCart();
})();
